module.exports = __webpack_public_path__ + "img/28_78.708562e0.png";